import { useState } from "react";
import dynamic from "next/dynamic";

import { type StartAgreementDrawerConfig, StartAgreementDrawerContext } from "~/contexts/StartAgreementDrawerContext";

const StartAgreementDrawer = dynamic(
  () =>
    typeof window === "undefined"
      ? Promise.resolve(() => null)
      : // oxlint-disable-next-line remi/no-async-import -- client-only; keeps StartAgreementDrawer (heic-to, heic2any, exifr) out of _app's chunk and every server function
        import("~/components/tasks/task-type-components/record-upsell-results/upsell-results-components/StartAgreementDrawer").then(
          (m) => m.StartAgreementDrawer,
        ),
  { ssr: false },
);

export const StartAgreementDrawerProvider = ({ children }: { children: React.ReactNode }) => {
  const [config, setConfig] = useState<StartAgreementDrawerConfig | null>(null);

  return (
    <StartAgreementDrawerContext.Provider value={{ openStartAgreement: setConfig }}>
      {children}
      {config && (
        <StartAgreementDrawer
          open
          onClose={() => setConfig(null)}
          readOnly={config.readOnly}
          bid={config.bid}
          homeowner={config.homeowner}
          quoteVersionOverrideId={config.quoteVersionOverrideId}
          requestForQuoteId={config.requestForQuoteId}
          taskId={config.taskId}
          isHrmAssigned={config.isHrmAssigned}
          isTaskCompleted={config.isTaskCompleted}
        />
      )}
    </StartAgreementDrawerContext.Provider>
  );
};
